<template>
    <div class="h-screen w-screen bg-red-500 justify-center items-center flex">
        <div class="">
            <h1 class="text-2xl w-full text-red-600 font-bold">
                Welcome to the super secret text reminder app dashboard
            </h1>
            <Link href="/dashboard">
                <p
                    class="text-sm text-white hover:underline w-full cursor-pointer"
                >
                    take me there
                </p>
            </Link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Index",
    props: ["name"]
};
</script>

<style scoped></style>
